import React from 'react'
import createCompanyInUserMutation from 'graphs/mutations/createCompanyInUser.graphql'
import companyValidation from 'validations/company'
import FormForRecord from 'components/FormForRecord'
import companyFields from 'fields/companies'

const RouteUsersCompaniesNew = ({ history: { goBack }, user, ...rest }) => (
  <FormForRecord
    mutation={createCompanyInUserMutation}
    onSuccess={goBack}
    onCancel={goBack}
    fields={companyFields}
    variables={{ user_id: user.id }}
    schema={companyValidation}
    title={`Create A Company for ${user.email}`}
    {...rest}
  />
)

export default RouteUsersCompaniesNew



// WEBPACK FOOTER //
// ./src/routes/admin/users/companies/new.js